import React from "react";
import { func, string, bool } from "prop-types";
import { Alert } from "react-bootstrap";
import jwtDecode from "jwt-decode";
import "!style-loader!css-loader!../styles.css";
import verificationLinkExpiredIcon from "resources/images/verification-link-expired.svg";
import circleSuccessIcon from "resources/images/circle-check-fill-dark-green.svg";

const InvalidVerifyLinkPage = ({
  verifyToken,
  handleResendVerificationEmail,
  resendVerificationEmailSuccess,
}) => {
  const decodedVerifyToken = jwtDecode(verifyToken);

  return (
    <>
      <div className="mb-4">
        <img
          src={verificationLinkExpiredIcon}
          alt="verification link expired"
        />
      </div>
      <h5 style={{ fontSize: "28px" }}>
        Your verification link is expired or invalid
      </h5>
      <div
        className="d-flex align-items-center my-4"
        style={{
          border: "1px solid #A9AAAC",
          borderRadius: "4px",
          borderLeft: "6px solid #425CC7",
          padding: "12px 16px",
          fontSize: "16px",
          textDecoration: "underline",
        }}
      >
        {decodedVerifyToken?.email}
      </div>
      <p className="mb-0" style={{ fontSize: "16px" }}>
        <span>
          <button
            type="button"
            className="btn-as-link-no-state font-weight-bold"
            onClick={handleResendVerificationEmail}
            id="resendVerificationEmailBtn"
            style={{ top: "0px" }}
          >
            Click here
          </button>
        </span>{" "}
        to resend the link to the email address above and complete your sign up.
      </p>
      {resendVerificationEmailSuccess && (
        <Alert
          variant="success"
          style={{
            backgroundColor: "#CCF2E1",
            border: "1px solid rgba(0, 192, 103, 0.20)",
            fontSize: "14px",
            marginTop: "32px",
          }}
        >
          <div className="d-flex" style={{ color: "#006034" }}>
            <img
              src={circleSuccessIcon}
              alt="success"
              className="mr-3 align-self-start"
            />
            Email verification link resent.
          </div>
        </Alert>
      )}
    </>
  );
};

InvalidVerifyLinkPage.propTypes = {
  handleResendVerificationEmail: func,
  verifyToken: string,
  resendVerificationEmailSuccess: bool,
};

export default InvalidVerifyLinkPage;
